import { Box, Collapse, Stack, Typography } from '@mui/material'
import { Field } from 'pages/TeenagersRecord/components/Field'
import React, { FC, useEffect, useState } from 'react'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import {
  formatAddresses,
  formatBirthdayEN,
  formatDocuments,
  formatInformedQuantity,
  formatNaturalness,
  formatPhones,
  formatText,
} from 'utils/text.util'
import Label from 'components/Label'
import AddIcon from '@mui/icons-material/Add'
import { FieldDocuments } from 'pages/TeenagersRecord/components/FieldDocuments'

type TabContentProps = {
  data: HearingIdentificationType
  isVisualize?: boolean
}

export const TabPersonalDataContent: React.FC<TabContentProps> = ({ data, isVisualize }) => {
  return (
    <Stack direction='column' spacing={2}>
      <Field label='Nome social:' value={[formatText(data.nomeSocial)]} direction='row' />
      <Field label='Nome:' value={[formatText(data.nome)]} direction='row' />
      <Field
        label='Data de nascimento:'
        value={[formatBirthdayEN(data.dataNascimento)]}
        direction='row'
      />
      <Field
        label='Idade:'
        value={[formatInformedQuantity(data.identificacaoAdolescente.idade)]}
        direction='row'
      />
      <Field label='Gênero:' value={[formatText(data.descricaoIdGenero)]} direction='row' />
      <Field label='Cor:' value={[formatText(data.descricaoIdRaca)]} direction='row' />
      <FieldDocuments label='Documento:' values={data.documentos} direction='column' />
      <Field
        label='Endereço:'
        value={formatAddresses(
          data.enderecos && data.enderecos.length > 0 && isVisualize
            ? [data.enderecos[0]]
            : data.enderecos,
        )}
        direction='column'
      />
      {data.enderecos && data.enderecos.length > 1 && isVisualize ? (
        <EnderecosAnteriores
          label={'Demais endereços'}
          value={formatAddresses(data.enderecos)}
          direction={'column'}
        />
      ) : null}

      <Field label='Telefone:' value={formatPhones(data.telefones)} direction='column' />
      <Field
        label='Nome do responsável pelo adolescente:'
        value={[formatText(data.nomeResponsavelAdolescente)]}
        direction='row'
      />
      <Field
        label='Email do adolescente/representante legal:'
        value={[formatText(data.email)]}
        direction='row'
      />
      <Field label='Nome da mãe:' value={[formatText(data.nomeMae)]} direction='row' />
      <Field label='Nome do pai:' value={[formatText(data.nomePai)]} direction='row' />
      <Field
        label='Naturalidade (Cidade/UF):'
        value={[
          formatNaturalness(
            data.descricaoIdMunicipioNaturalidade,
            data.descricaoIdEstadoNaturalidade,
          ),
        ]}
        direction='row'
      />
    </Stack>
  )
}

type EnderecosAnterioresProps = {
  label: string
  value: string[]
  direction: 'column' | 'row'
}

const EnderecosAnteriores: FC<EnderecosAnterioresProps> = ({ label, direction, value }) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  useEffect(() => {
    if (value) {
      value.shift()
    }
  }, [value])

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const directionProps = direction === 'row' ? { spacing: 1 } : null

  return (
    <Stack direction={direction} {...directionProps}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          minWidth: '25rem',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleExpandClick}
      >
        <AddIcon sx={{ marginRight: '0.25rem' }} />
        <Typography variant={'body1'}>{label}</Typography>
      </Box>
      <Collapse in={expanded} timeout={'auto'} unmountOnExit>
        {value && value.map((item, index) => <Label key={index} text={item} v='body1' />)}
      </Collapse>
    </Stack>
  )
}
